///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { GtthSharedModule } from '../shared.module';
import { RouterModule, Routes } from '@angular/router';
import { GtthReportProblemModalComponent, GtthReportProblemPopupComponent } from './report-problem/report-problem-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SuiLoadingDirective, SuiSvgIconComponent, SuiTranslatePipe } from '@siklu/sui-lib';

const routes: Routes = [
    {
        path: 'feedback/report-problem',
        component: GtthReportProblemPopupComponent,
        data: {
            pageTitle: 'navbar.reportProblem'
        },
        outlet: 'popup'
    }
];

@NgModule({
    imports: [GtthSharedModule, MatDialogModule, RouterModule.forChild(routes), SuiLoadingDirective, SuiSvgIconComponent, SuiTranslatePipe],
    declarations: [GtthReportProblemModalComponent, GtthReportProblemPopupComponent],
    providers: []
})
export class GtthFeedbackModule {}
